import * as back from '~/components/layouts/Navigation/BreadcrumbContainer/functional/backLinks';
import { generateReportRules } from '~/components/layouts/Navigation/BreadcrumbContainer/functional/config/reportConfig';
import * as match from '~/components/layouts/Navigation/BreadcrumbContainer/functional/matchers';
import type { RouteRule } from '~/components/layouts/Navigation/BreadcrumbContainer/functional/types';

const PRIORITY = {
  SECTION_BASE: 500,
  REPORT_DETAIL: 520,
} as const;

const legacyReportPages: Record<string, { labelKey: string; link: string }> = {
  '/prepaid-rent': { labelKey: 'Prepaid rent report', link: '/reports/prepaid-rent' },
  '/rent-payments': { labelKey: 'Rent payments report', link: '/reports/rent-payments' },
  '/late-fees': { labelKey: 'Late fees charged report', link: '/reports/late-fees' },
  '/general-ledger': { labelKey: 'General ledger', link: '/reports/general-ledger' },
  '/income-statement': { labelKey: 'Income statement report', link: '/reports/income-statement' },
  '/owner-statement': { labelKey: 'Owner statement', link: '/reports/owner-statement' },
  '/property-directory': { labelKey: 'Property directory', link: '/reports/property-directory' },
  '/owner-directory': { labelKey: 'Owner directory', link: '/reports/owner-directory' },
  '/tenant-directory': { labelKey: 'Tenant directory', link: '/reports/tenant-directory' },
  '/bank-account-activity': { labelKey: 'Bank account activity report', link: '/reports/bank-account-activity' },
  '/lease-unpaid-bills': { labelKey: 'Lease unpaid bills', link: '/reports/lease-unpaid-bills' },
  '/delinquency-report': { labelKey: 'Delinquency report', link: '/reports/delinquency-report' },
  '/property-reserve': { labelKey: 'Property reserve report', link: '/reports/property-reserve' },
};

export const reportRules: RouteRule[] = [
  ...generateReportRules().map((rule, index) => ({
    ...rule,
    priority: PRIORITY.REPORT_DETAIL + index,
  })),
  ...Object.entries(legacyReportPages).map(([key, config], index) => ({
    match: match.and(match.startsWith('/reports'), match.includes(key)),
    generate: (context: any) => [
      { label: context.t('Reports') },
      { label: context.t(config.labelKey), link: config.link, linkClass: 'text-black' },
    ],
    backLink: back.goBack,
    priority: PRIORITY.REPORT_DETAIL + 100 + index,
  })),
  {
    match: match.startsWith('/reports'),
    generate: (context) => {
      const link = context.path === '/reports' ? context.path : '/reports';
      return [{ label: context.t('Reports'), link }];
    },
    backLink: back.homeLink,
    priority: PRIORITY.SECTION_BASE,
  },
];
